import styled, { css } from 'styled-components';

export enum AvatarVariant {
  Success = 'success',
  Danger = 'danger',
  Primary = 'primary',
  Secondary = 'secondary',
}

export const Avatar = styled.div<{ size?: 'small' | 'large'; variant?: AvatarVariant }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.secondary.blendToBackground(600)};
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: ${({ theme }) => theme.secondary.blendToBackground(50)};
  box-shadow: 0 0 0 1px ${({ theme }) => theme.secondary.blendToBackground(150)};

  ${({ variant }) =>
    variant === AvatarVariant.Secondary &&
    css`
      color: ${({ theme }) => theme.secondary.blendToBackground(600)};
      background: ${({ theme }) => theme.background};
      box-shadow: 0 0 0 1px ${({ theme }) => theme.secondary.blendToBackground(250)};
    `}

  ${({ variant }) =>
    variant === AvatarVariant.Danger &&
    css`
      color: ${({ theme }) => theme.danger.background};
      background: ${({ theme }) => theme.danger.blendToBackground(1000, 100)};
      box-shadow: 0 0 0 1px ${({ theme }) => theme.danger.blendToBackground(400)};
    `}

  ${({ variant }) =>
    variant === AvatarVariant.Success &&
    css`
      color: ${({ theme }) => theme.success.background};
      background: ${({ theme }) => theme.success.blendToBackground(1000, 150)};
      box-shadow: 0 0 0 1px ${({ theme }) => theme.success.blendToBackground(400)};
    `}

${({ size }) =>
    size === 'small' &&
    css`
      width: 20px;
      height: 20px;

      border-radius: 6px;
      box-shadow: none;

      svg {
        --icon-size: 18px;
      }
    `}

${({ size }) =>
    size === 'large' &&
    css`
      width: 40px;
      height: 40px;
    `}
`;
